module.exports = __webpack_public_path__ + "static/media/rw.25cc4c5f.svg";